import { notFound } from "@tanstack/react-router";
import { createServerFn } from "@tanstack/react-start";
import { siteContext } from "../server/site.server";
import { guidePage, guidesIndex } from "./guides.server";
import { platformPageResponse } from "./page-response";
import { regularPlanShown } from "./plan-flag.server";

/** /guides, on Drate's own host only; a creator's site answers it with its own 404. */
export const loadGuides = createServerFn({ method: "GET" }).handler(async ({ context }) => {
  const drate = await siteContext(context);
  if (drate.creator) return null;
  platformPageResponse(drate);
  return guidesIndex(drate.env.APP_ORIGIN, await regularPlanShown(drate));
});

/** One guide (/guides/<slug>), on Drate's own host only. */
export const loadGuide = createServerFn({ method: "GET" })
  .validator((slug: unknown) => {
    if (typeof slug !== "string" || !/^[a-z0-9-]{1,120}$/.test(slug)) throw notFound();
    return slug;
  })
  .handler(async ({ data: slug, context }) => {
    const drate = await siteContext(context);
    if (drate.creator) return null;
    platformPageResponse(drate);
    return guidePage(drate.env.APP_ORIGIN, slug, await regularPlanShown(drate));
  });
